import { faFraction } from '../../lib/faNumbers'
import styles from './CapacityBar.module.css'

interface CapacityBarProps {
  /** Derived locally when offline: last confirmed count plus queued adds minus removes. */
  itemCount: number
  capacityMax: number
}

export function CapacityBar({ itemCount, capacityMax }: CapacityBarProps) {
  const percent = capacityMax > 0 ? Math.min(100, Math.round((itemCount / capacityMax) * 100)) : 0
  const atCeiling = capacityMax > 0 && itemCount >= capacityMax

  return (
    <div className={styles.wrap}>
      <div
        className={styles.track}
        role="progressbar"
        aria-valuenow={itemCount}
        aria-valuemin={0}
        aria-valuemax={capacityMax}
        aria-label="ظرفیت پالت"
      >
        <div
          className={`${styles.fill} ${atCeiling ? styles.full : ''}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <div className={styles.row}>
        <span>ظرفیت پالت</span>
        {/*
          This number can exceed the server's while scans are queued. It is a local
          estimate and nothing gates on it: «ظرفیت پالت پر شده است» fires on a server
          pallet_full reject, because another handheld may have filled the pallet too.
        */}
        <span className={styles.value}>{faFraction(itemCount, capacityMax)}</span>
      </div>
    </div>
  )
}
